'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'UIPopoverFooter',

  propTypes: {
    align: _react.PropTypes.oneOf(['left', 'right']).isRequired,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      align: 'left'
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        align = _props.align,
        className = _props.className;

    return (0, _reactUtils.classNames)('uiPopoverFooter', 'private-popover__footer', className, { 'text-right': align === 'right' });
  },
  render: function render() {
    var children = this.props.children;

    return _react2.default.createElement(
      'footer',
      { className: this.getClassName() },
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/tooltip/UIPopoverFooter.js
// module id = 260
// module chunks = 0 1